import React from 'react';
import PropTypes from 'prop-types';

export const VerificationComplete = ({ width, height, ...props }) => (
  <svg
    data-icon='verification-complete'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M12 22c-2.317-.583-4.23-1.913-5.737-3.988C4.754 15.938 4 13.633 4 11.1V5l8-3 8 3v5.675a12.35 12.35 0 0 0-.975-.363A6.104 6.104 0 0 0 18 10.075V6.4l-6-2.25L6 6.4v4.7c0 .783.104 1.567.313 2.35.208.783.5 1.53.875 2.238s.829 1.362 1.362 1.962c.533.6 1.125 1.1 1.775 1.5a7.515 7.515 0 0 0 1.75 2.825c-.017 0-.03.004-.037.012-.009.009-.021.013-.038.013Z'
    />
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M13.463 20.538C14.438 21.512 15.617 22 17 22s2.563-.488 3.538-1.462C21.512 19.562 22 18.383 22 17s-.488-2.563-1.462-3.537C19.562 12.488 18.383 12 17 12s-2.563.488-3.537 1.463C12.488 14.438 12 15.617 12 17s.488 2.563 1.463 3.538ZM14 17.372l2.083 2.128 4.167-4.255-.73-.745-3.437 3.51-1.354-1.382-.729.744Z'
      clipRule='evenodd'
    />
  </svg>
);

VerificationComplete.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

VerificationComplete.defaultProps = {
  width: 24,
  height: 24,
};
